<template>
  <div style="position: relative; min-height: 300px;">
    <el-row class="canvas" v-if="chartData">
      <el-col :xl="18" :sm="24">
        <chart-line :data="chartData" v-if="chartData"></chart-line>
      </el-col>
      <el-col :xl="6" :sm="24">
        <chart-pie :data="chartData" v-if="chartData"></chart-pie>
      </el-col>
    </el-row>
    <div v-else style="text-align: center; padding-top: 100px; color: #777;">暂无图表数据</div>
    <!-- <div class="header left">
      <span class="title">订单、产品日期分布</span>
      <el-tooltip class="item" effect="dark" content="日期为订单付款日期、产品上市日期。" placement="top-start">
        <span class="el-icon-warning-outline"></span>
      </el-tooltip>
    </div> -->
    <div class="header right">
      <el-radio-group v-model="radio" size="mini" @change="handleRadioChange">
        <el-radio-button label="1">上月</el-radio-button>
        <el-radio-button label="2">本月</el-radio-button>
        <el-radio-button label="3">近半月</el-radio-button>
        <el-radio-button label="">全部</el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import chartLine from './components/chartLine/chartLine'
import chartPie from './components/chartPie/chartPie'
export default {
  components: { chartLine, chartPie },
  props: ['data'],
  data() {
    return {
      chartData: null,
      radio: ''
    }
  },
  computed: {
    formData() {
      return this.data
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    search() {
      this.init()
    },
    init() {
      this.chartData = null;

      let data = {
        ...this.formData
      }

      return this.$q.orderDate.deliveryShortageScatteredInfo({data: data})
      .then(res=>{
        if(res.success && res.data && Object.values(res.data).map(v=>v.count).filter(v=>v>0).length > 0) {
          this.chartData = res.data;
        }
      })
    },
    handleRadioChange(data) {
      this.$bus.$emit('updateChartsData',data)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .header
    position absolute
    top 0
    width auto
    z-index 999
    &.left
      left 0
    &.right
      right 0
      top 5px

  .title
    font-size 16px
    line-height 36px
    color #444444
  >>> .el-icon-warning-outline
    font-size 16px

  .canvas.el-row, .canvas >>> .el-col
    height 100%
</style>
